import { useABTesting } from '@/hooks/abTesting';

export enum ExpRegSliderDecreaseSize {
  A = 'a_with_recent_games_section',
  B = 'b_without_recent_games_section',
}

export const useIsSliderDecreaseSize = () => {
  const isSliderDecreaseSize =
    useABTesting('slider_decrease_size', {
      defaultVersion: ExpRegSliderDecreaseSize.A,
      versions: [
        { name: ExpRegSliderDecreaseSize.A, probability: 50 },
        { name: ExpRegSliderDecreaseSize.B, probability: 50 },
      ],
      authorized: true,
      platform: 'mobile',
    }) === ExpRegSliderDecreaseSize.B;

  return isSliderDecreaseSize;
};
